<app-dialog-wrapper [content]="{title: data.title, descr: []}">
	<div class="dialog-confirm-wrapper">
		<div class="dialog-confirm-content">
			{{data.message}}
		</div>
		<div class="dialog-footer">
			<div class="dialog-btn" (click)="onCancel()">Cancel</div>
			<div class="dialog-btn" (click)="onConfirm()">Confirm</div>
		</div>
	</div>
</app-dialog-wrapper>
